<!-- src/components/student/StudentHeader.vue -->
<template>
	<header class="sh-header" role="banner">
		<div class="sh-container">
			<!-- Логотип -->
			<div class="sh-logo">
				<div class="sh-logo-wrapper">
					<X62 variant="header" />
				</div>
			</div>

			<!-- Навигация -->
			<nav class="sh-nav" role="navigation">
				<!-- Главная -->
				<router-link
					to="/student"
					class="sh-nav-link"
					aria-label="Главная страница"
				>
					<div class="sh-nav-link-content">
						<div class="sh-nav-icon-wrapper">
							<svg class="sh-nav-icon" viewBox="0 0 24 24" fill="none">
								<path
									d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"
									stroke="currentColor"
									stroke-width="2"
									stroke-linecap="round"
									stroke-linejoin="round"
								/>
								<path
									d="M9 22V12h6v10"
									stroke="currentColor"
									stroke-width="2"
									stroke-linecap="round"
									stroke-linejoin="round"
								/>
							</svg>
						</div>
						<span class="sh-nav-label">Главная</span>
					</div>
					<div class="sh-nav-link-indicator"></div>
				</router-link>

				<!-- Сообщения -->
				<!-- <button
                    type="button"
                    class="sh-nav-btn"
                    @click="handleMessages"
                    :class="{ 'sh-nav-btn--active': safeMessagesCount > 0 }"
                    :aria-label="`Сообщения${
                        safeMessagesCount > 0 ? ` (${safeMessagesCount} новых)` : ''
                    }`"
                >
                    <div class="sh-nav-btn-content">
                        <div class="sh-nav-icon-wrapper">
                            <svg class="sh-nav-icon" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                            <transition name="badge-pop">
                                <span
                                    v-if="safeMessagesCount > 0"
                                    class="sh-badge sh-badge--primary"
                                >
                                    {{ messagesBadge }}
                                </span>
                            </transition>
                        </div>
                        <span class="sh-nav-label">Сообщения</span>
                    </div>
                </button> -->

				<!-- Уведомления -->
				<div class="sh-notifications" ref="notificationsContainer">
					<button
						type="button"
						class="sh-nav-btn"
						@click="handleNotifications"
						:class="{ 'sh-nav-btn--active': safeNotificationsCount > 0 }"
						:aria-label="`Уведомления${
							safeNotificationsCount > 0
								? ` (${safeNotificationsCount} новых)`
								: ''
						}`"
						:aria-expanded="notificationsOpen"
					>
						<div class="sh-nav-btn-content">
							<div class="sh-nav-icon-wrapper">
								<svg class="sh-nav-icon" viewBox="0 0 24 24" fill="none">
									<path
										d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"
										stroke="currentColor"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
									<path
										d="M13.73 21a2 2 0 01-3.46 0"
										stroke="currentColor"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
								</svg>
								<transition name="badge-pop">
									<span
										v-if="safeNotificationsCount > 0"
										class="sh-badge sh-badge--danger"
									>
										{{ notificationsBadge }}
									</span>
								</transition>
							</div>
							<span class="sh-nav-label">Уведомления</span>
						</div>
					</button>

					<transition name="sh-dropdown">
						<div
							v-if="notificationsOpen"
							class="sh-notifications-dropdown"
							role="menu"
							@click.stop
						>
							<div class="sh-notifications-header">
								<span>Уведомления</span>
								<button
									v-if="notificationsList.length"
									type="button"
									class="sh-notifications-clear"
									@click="clearNotifications"
								>
									Очистить
								</button>
							</div>

							<div
								v-if="!notificationsList.length"
								class="sh-notifications-empty"
							>
								Новых уведомлений нет.
							</div>
							<ul v-else class="sh-notifications-list">
								<li
									v-for="item in notificationsList"
									:key="item.id"
									class="sh-notifications-item"
								>
									<div class="sh-notifications-item-title">
										{{ item.title || 'Уведомление' }}
									</div>
									<div class="sh-notifications-item-text">
										{{ item.message || '' }}
									</div>
									<div class="sh-notifications-item-time">
										{{ formatNotificationTime(item.timestamp) }}
									</div>
									<button
										type="button"
										class="sh-notifications-close"
										aria-label="Удалить уведомление"
										@click.stop="removeNotification(item.id)"
									>
										<svg viewBox="0 0 24 24" fill="none">
											<path
												d="M18 6L6 18M6 6l12 12"
												stroke="currentColor"
												stroke-width="2"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
										</svg>
									</button>
								</li>
							</ul>
						</div>
					</transition>
				</div>
			</nav>

			<!-- Правая часть -->
			<div class="sh-actions">
				<!-- ПОИСК С АВТОДОПОЛНЕНИЕМ -->
				<div
					class="sh-search"
					:class="{ 'sh-search--active': searchFocused || searchQuery }"
					ref="searchContainer"
				>
					<!-- Поле ввода -->
					<div class="sh-search-field">
						<input
							ref="searchInput"
							v-model="searchQuery"
							type="text"
							class="sh-search-input"
							placeholder="Поиск курсов, уроков..."
							@focus="handleSearchFocus"
							@blur="handleSearchBlur"
							@input="handleSearchInput"
							@keydown="handleSearchKeydown"
							:aria-expanded="showSearchDropdown"
							aria-autocomplete="list"
							aria-controls="search-results"
							autocomplete="off"
						/>

						<!-- Кнопка очистки -->
						<button
							v-if="searchQuery"
							type="button"
							class="sh-search-clear"
							@click="clearSearch"
							aria-label="Очистить поиск"
						>
							<svg width="14" height="14" viewBox="0 0 24 24" fill="none">
								<path
									d="M18 6L6 18M6 6l12 12"
									stroke="currentColor"
									stroke-width="2"
									stroke-linecap="round"
								/>
							</svg>
						</button>

						<!-- Кнопка поиска -->
						<!-- <button
                            type="button"
                            class="sh-search-btn"
                            @click="executeSearch"
                            :class="{ 'sh-search-btn--active': searchQuery }"
                            aria-label="Выполнить поиск"
                        >
                            <svg v-if="!isSearching" viewBox="0 0 24 24" fill="none">
                                <circle
                                    cx="11"
                                    cy="11"
                                    r="8"
                                    stroke="currentColor"
                                    stroke-width="2"
                                />
                                <path
                                    d="M21 21l-4.35-4.35"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                />
                            </svg> -->
						<!-- Индикатор загрузки -->
						<!-- <div v-else class="sh-search-spinner">
                                <svg viewBox="0 0 24 24" fill="none">
                                    <circle
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        opacity="0.25"
                                    />
                                    <path
                                        d="M12 2a10 10 0 010 20"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                    />
                                </svg>
                            </div>
                        </button> -->
					</div>

					<!-- Dropdown с результатами -->
					<transition name="search-dropdown">
						<div
							v-if="showSearchDropdown"
							id="search-results"
							class="sh-search-dropdown"
							@mousedown.prevent
						>
							<!-- Быстрые фильтры -->
							<div
								v-if="!searchQuery && !searchResults.length"
								class="sh-search-quick"
							>
								<!-- История поиска -->
								<div v-if="searchHistory.length > 0" class="sh-search-history">
									<div class="sh-search-section-header">
										<span class="sh-search-section-title">Недавний поиск</span>
										<button
											type="button"
											class="sh-search-clear-history"
											@click="clearSearchHistory"
										>
											Очистить
										</button>
									</div>
									<div
										v-for="(item, index) in searchHistory"
										:key="`history-${index}`"
										class="sh-search-history-item"
										@click="selectFromHistory(item)"
										role="button"
										tabindex="0"
										@keydown.enter.prevent="selectFromHistory(item)"
										@keydown.space.prevent="selectFromHistory(item)"
									>
										<svg width="14" height="14" viewBox="0 0 24 24" fill="none">
											<circle
												cx="12"
												cy="12"
												r="10"
												stroke="currentColor"
												stroke-width="2"
											/>
											<path
												d="M12 6v6l4 2"
												stroke="currentColor"
												stroke-width="2"
												stroke-linecap="round"
											/>
										</svg>
										<span>{{ item }}</span>
										<button
											type="button"
											class="sh-search-history-remove"
											@click.stop="removeFromHistory(index)"
											aria-label="Удалить из истории"
										>
											<svg
												width="12"
												height="12"
												viewBox="0 0 24 24"
												fill="none"
											>
												<path
													d="M18 6L6 18M6 6l12 12"
													stroke="currentColor"
													stroke-width="2"
													stroke-linecap="round"
												/>
											</svg>
										</button>
									</div>
								</div>
							</div>

							<!-- Результаты поиска -->
							<div v-else-if="isSearching" class="sh-search-loading">
								<div class="sh-search-loading-spinner"></div>
								<span>Поиск...</span>
							</div>

							<div
								v-else-if="searchResults.length > 0"
								class="sh-search-results"
							>
								<!-- Категории результатов -->
								<div v-if="courseResults.length > 0" class="sh-search-category">
									<div class="sh-search-category-header">
										<span class="sh-search-category-title">Курсы</span>
										<span class="sh-search-category-count">{{
											courseResults.length
										}}</span>
									</div>
									<router-link
										v-for="(course, index) in courseResults.slice(0, 3)"
										:key="`course-${course.id}`"
										:to="{
											name: 'CoursePreview',
											params: { id: course.id },
										}"
										class="sh-search-result"
										:class="{
											'sh-search-result--active': selectedIndex === index,
										}"
										@click="selectResult(course)"
									>
										<div class="sh-search-result-icon">
											<svg
												width="16"
												height="16"
												viewBox="0 0 24 24"
												fill="none"
											>
												<path
													d="M12 2L2 7v10c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-10-5z"
													stroke="currentColor"
													stroke-width="2"
												/>
											</svg>
										</div>
										<div class="sh-search-result-content">
											<div
												class="sh-search-result-title"
												v-html="highlightMatch(course.title)"
											></div>
											<div class="sh-search-result-meta">
												{{ course.lessons }} уроков •
												{{ course.duration }}
											</div>
										</div>
										<div class="sh-search-result-badge" v-if="course.isNew">
											NEW
										</div>
									</router-link>
								</div>

								<div v-if="lessonResults.length > 0" class="sh-search-category">
									<div class="sh-search-category-header">
										<span class="sh-search-category-title">Уроки</span>
										<span class="sh-search-category-count">{{
											lessonResults.length
										}}</span>
									</div>
									<router-link
										v-for="lesson in lessonResults.slice(0, 3)"
										:key="`lesson-${lesson.id}`"
										:to="`/student/lesson/${lesson.id}`"
										class="sh-search-result"
										@click="selectResult(lesson)"
									>
										<div class="sh-search-result-icon">
											<svg
												width="16"
												height="16"
												viewBox="0 0 24 24"
												fill="none"
											>
												<circle
													cx="12"
													cy="12"
													r="10"
													stroke="currentColor"
													stroke-width="2"
												/>
												<polygon
													points="10 8 16 12 10 16"
													fill="currentColor"
												/>
											</svg>
										</div>
										<div class="sh-search-result-content">
											<div
												class="sh-search-result-title"
												v-html="highlightMatch(lesson.title)"
											></div>
											<div class="sh-search-result-meta">
												{{ lesson.courseName }} • {{ lesson.duration }}
											</div>
										</div>
									</router-link>
								</div>

								<!-- Показать все результаты -->
								<button
									v-if="totalResults > 6"
									type="button"
									class="sh-search-show-all"
									@click="showAllResults"
								>
									Показать все результаты ({{ totalResults }})
									<svg width="14" height="14" viewBox="0 0 24 24" fill="none">
										<path
											d="M9 18l6-6-6-6"
											stroke="currentColor"
											stroke-width="2"
											stroke-linecap="round"
										/>
									</svg>
								</button>
							</div>

							<!-- Нет результатов -->
							<div
								v-else-if="searchQuery && !isSearching"
								class="sh-search-empty"
							>
								<svg width="48" height="48" viewBox="0 0 24 24" fill="none">
									<circle
										cx="11"
										cy="11"
										r="8"
										stroke="currentColor"
										stroke-width="2"
										opacity="0.25"
									/>
									<path
										d="M21 21l-4.35-4.35"
										stroke="currentColor"
										stroke-width="2"
										stroke-linecap="round"
										opacity="0.25"
									/>
									<path
										d="M8 11h6M11 8v6"
										stroke="currentColor"
										stroke-width="2"
										stroke-linecap="round"
									/>
								</svg>
								<p class="sh-search-empty-title">Ничего не найдено</p>
								<p class="sh-search-empty-text">Попробуйте изменить запрос</p>

								<!-- Предложения -->
								<div
									class="sh-search-suggestions"
									v-if="searchSuggestions.length > 0"
								>
									<p class="sh-search-suggestions-title">
										Возможно, вы искали:
									</p>
									<div class="sh-search-tags">
										<button
											v-for="suggestion in searchSuggestions"
											:key="suggestion"
											type="button"
											class="sh-search-tag"
											@click="selectSuggestion(suggestion)"
										>
											{{ suggestion }}
										</button>
									</div>
								</div>
							</div>
						</div>
					</transition>
				</div>

				<!-- Профиль -->
				<div class="sh-profile" ref="profileContainer">
					<button
						ref="dropdownTrigger"
						type="button"
						class="sh-profile-btn"
						@click="toggleDropdown"
						:aria-expanded="isOpen"
					>
						<div class="sh-profile-avatar">
							<div class="sh-profile-avatar-clip">
								<img
									v-if="safeAvatarUrl"
									:src="safeAvatarUrl"
									:alt="`Аватар пользователя`"
									class="sh-profile-avatar-img"
									@error="handleAvatarError"
									referrerpolicy="no-referrer"
									crossorigin="anonymous"
								/>
								<div v-else class="sh-profile-avatar-placeholder">
									{{ safeUserInitials }}
								</div>
							</div>
							<div class="sh-profile-status"></div>
						</div>

						<div class="sh-profile-info">
							<span class="sh-profile-name">{{ safeUserName }}</span>
							<span class="sh-profile-role">{{ userRole }}</span>
						</div>
						<svg
							class="sh-profile-arrow"
							:class="{ 'sh-profile-arrow--open': isOpen }"
							viewBox="0 0 24 24"
							fill="none"
						>
							<path
								d="M6 9l6 6 6-6"
								stroke="currentColor"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</svg>
					</button>

					<!-- Dropdown меню -->
					<transition name="sh-dropdown">
						<div v-if="isOpen" class="sh-dropdown" role="menu" @click.stop>
							<!-- Профиль header в dropdown -->
							<div class="sh-dropdown-header">
								<div class="sh-dropdown-avatar">
									<img
										v-if="safeAvatarUrl"
										:src="safeAvatarUrl"
										alt=""
										@error="handleAvatarError"
										referrerpolicy="no-referrer"
										crossorigin="anonymous"
									/>
									<div v-else class="sh-dropdown-avatar-placeholder">
										{{ safeUserInitials }}
									</div>
								</div>
								<div class="sh-dropdown-user">
									<div class="sh-dropdown-username">{{ safeUserName }}</div>
									<div class="sh-dropdown-email">{{ maskedEmail }}</div>
								</div>
							</div>

							<div class="sh-dropdown-divider"></div>

							<!-- Menu items -->
							<router-link
								to="/student-dashboard/profile"
								class="sh-dropdown-item"
								@click="closeDropdown"
							>
								<svg class="sh-dropdown-icon" viewBox="0 0 24 24" fill="none">
									<path
										d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"
										stroke="currentColor"
										stroke-width="2"
										stroke-linecap="round"
									/>
									<circle
										cx="12"
										cy="7"
										r="4"
										stroke="currentColor"
										stroke-width="2"
									/>
								</svg>
								<span>Мой профиль</span>
							</router-link>

							<router-link
								to="/student-dashboard/settings"
								class="sh-dropdown-item"
								@click="closeDropdown"
							>
								<svg class="sh-dropdown-icon" viewBox="0 0 16 16" fill="none">
									<path
										d="M15.2 6l-1.1-0.2c-0.1-0.2-0.1-0.4-0.2-0.6l0.6-0.9 0.5-0.7-2.6-2.6-0.7 0.5-0.9 0.6c-0.2-0.1-0.4-0.1-0.6-0.2l-0.2-1.1-0.2-0.8h-3.6l-0.2 0.8-0.2 1.1c-0.2 0.1-0.4 0.1-0.6 0.2l-0.9-0.6-0.7-0.4-2.5 2.5 0.5 0.7 0.6 0.9c-0.2 0.2-0.2 0.4-0.3 0.6l-1.1 0.2-0.8 0.2v3.6l0.8 0.2 1.1 0.2c0.1 0.2 0.1 0.4 0.2 0.6l-0.6 0.9-0.5 0.7 2.6 2.6 0.7-0.5 0.9-0.6c0.2 0.1 0.4 0.1 0.6 0.2l0.2 1.1 0.2 0.8h3.6l0.2-0.8 0.2-1.1c0.2-0.1 0.4-0.1 0.6-0.2l0.9 0.6 0.7 0.5 2.6-2.6-0.5-0.7-0.6-0.9c0.1-0.2 0.2-0.4 0.2-0.6l1.1-0.2 0.8-0.2v-3.6l-0.8-0.2zM15 9l-1.7 0.3c-0.1 0.5-0.3 1-0.6 1.5l0.9 1.4-1.4 1.4-1.4-0.9c-0.5 0.3-1 0.5-1.5 0.6l-0.3 1.7h-2l-0.3-1.7c-0.5-0.1-1-0.3-1.5-0.6l-1.4 0.9-1.4-1.4 0.9-1.4c-0.3-0.5-0.5-1-0.6-1.5l-1.7-0.3v-2l1.7-0.3c0.1-0.5 0.3-1 0.6-1.5l-1-1.4 1.4-1.4 1.4 0.9c0.5-0.3 1-0.5 1.5-0.6l0.4-1.7h2l0.3 1.7c0.5 0.1 1 0.3 1.5 0.6l1.4-0.9 1.4 1.4-0.9 1.4c0.3 0.5 0.5 1 0.6 1.5l1.7 0.3v2z"
										fill="currentColor"
									/>
									<path
										d="M8 4.5c-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5 3.5-1.6 3.5-3.5c0-1.9-1.6-3.5-3.5-3.5zM8 10.5c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5c0 1.4-1.1 2.5-2.5 2.5z"
										fill="currentColor"
									/>
								</svg>
								<span>Настройки</span>
							</router-link>

							<div class="sh-dropdown-divider"></div>

							<router-link
								to="/help"
								class="sh-dropdown-item"
								@click="closeDropdown"
							>
								<svg class="sh-dropdown-icon" viewBox="0 0 24 24" fill="none">
									<circle
										cx="12"
										cy="12"
										r="10"
										stroke="currentColor"
										stroke-width="2"
									/>
									<path
										d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"
										stroke="currentColor"
										stroke-width="2"
										stroke-linecap="round"
									/>
									<circle cx="12" cy="17" r="0.5" fill="currentColor" />
								</svg>
								<span>Помощь</span>
							</router-link>

							<div class="sh-dropdown-divider"></div>

							<button
								type="button"
								class="sh-dropdown-item sh-dropdown-item--danger"
								@click="handleLogout"
								:disabled="isLoggingOut"
							>
								<svg class="sh-dropdown-icon" viewBox="0 0 24 24" fill="none">
									<path
										d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9"
										stroke="currentColor"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
								</svg>
								<span>{{ isLoggingOut ? 'Выход...' : 'Выйти' }}</span>
							</button>
						</div>
					</transition>
				</div>
			</div>
		</div>
	</header>
</template>

<script>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { useRouter } from 'vue-router'
import { debounce } from 'lodash-es'
import DOMPurify from 'dompurify'
import X62 from '@/components/X62.vue'
import { useAppStore } from '@/stores/useAppStore'
import { api } from '@/services'
import accountSocket from '@/services/accountSocket'
import { searchService } from '@/services/searchService'

// Безопасные утилиты
const SecurityUtils = {
	sanitizeText(text) {
		if (!text) return ''
		return DOMPurify.sanitize(text, { ALLOWED_TAGS: [] })
	},

	isValidImageUrl(url) {
		if (!url) return false

		// Разрешаем относительные пути (начинаются с /)
		if (url.startsWith('/')) {
			const ext = url.split('.').pop().toLowerCase().split('?')[0]
			return ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'].includes(ext)
		}

		try {
			const urlObj = new URL(url)
			if (!['https:', 'http:', 'data:'].includes(urlObj.protocol)) {
				return false
			}
			if (urlObj.protocol === 'https:' || urlObj.protocol === 'http:') {
				const ext = urlObj.pathname.split('.').pop().toLowerCase()
				if (!['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'].includes(ext)) {
					return false
				}
			}
			return true
		} catch {
			return false
		}
	},

	maskEmail(email) {
		if (!email || !email.includes('@')) return '***@***.***'
		const [local, domain] = email.split('@')
		const maskedLocal =
			local.length > 2
				? local[0] + '*'.repeat(local.length - 2) + local[local.length - 1]
				: '*'.repeat(local.length)
		const [domainName, ...domainExt] = domain.split('.')
		const maskedDomain = domainName[0] + '*'.repeat(domainName.length - 1)
		return `${maskedLocal}@${maskedDomain}.${domainExt.join('.')}`
	},

	createRateLimiter(maxAttempts = 5, windowMs = 60000) {
		const attempts = new Map()

		return function (key) {
			const now = Date.now()
			const userAttempts = attempts.get(key) || []
			const recentAttempts = userAttempts.filter(time => now - time < windowMs)

			if (recentAttempts.length >= maxAttempts) {
				return false
			}

			recentAttempts.push(now)
			attempts.set(key, recentAttempts)
			return true
		}
	},
}

const NOTIFICATIONS_ENDPOINT =
	import.meta.env?.VITE_NOTIFICATIONS_ENDPOINT ||
	process.env.VUE_APP_NOTIFICATIONS_ENDPOINT ||
	'/notifications'
const NOTIFICATIONS_COUNT_ENDPOINT = `${NOTIFICATIONS_ENDPOINT}/unread-count`
const NOTIFICATIONS_READ_ALL_ENDPOINT = `${NOTIFICATIONS_ENDPOINT}/read-all`

export default {
	name: 'StudentHeader',

	components: { X62 },

	props: {
		messagesCount: {
			type: Number,
			default: 0,
			validator: value => value >= 0 && value <= 9999,
		},
		notificationsCount: {
			type: Number,
			default: 0,
			validator: value => value >= 0 && value <= 9999,
		},
		userRole: {
			type: String,
			default: 'Студент',
			validator: value =>
				['Студент', 'Преподаватель', 'Администратор'].includes(value),
		},
	},

	emits: ['search', 'open-messages', 'open-notifications', 'logout'],

	setup(props, { emit }) {
		const router = useRouter()
		const appStore = useAppStore()

		// Rate limiters
		const logoutRateLimiter = SecurityUtils.createRateLimiter(3, 60000)

		// Поиск - состояние
		const searchContainer = ref(null)
		const searchInput = ref(null)
		const searchQuery = ref('')
		const searchFocused = ref(false)
		const showSearchDropdown = ref(false)
		const isSearching = ref(false)
		const searchResults = ref([])
		const selectedIndex = ref(-1)

		// История поиска
		const searchHistory = ref([])
		const searchSuggestions = ref([])

		// Профиль
		const isOpen = ref(false)
		const isLoggingOut = ref(false)
		const profileContainer = ref(null)
		const dropdownTrigger = ref(null)
		const avatarError = ref(false)
		const notificationsOpen = ref(false)
		const notificationsContainer = ref(null)
		const notificationsLoading = ref(false)
		const notificationsError = ref('')
		const notificationsListApi = ref([])
		const notificationsApiAvailable = ref(true)
		const hasFetchedNotifications = ref(false)
		const unreadCount = ref(null)
		const notificationsBackoffUntil = ref(0)
		const unreadCountRequestInFlight = ref(false)
		const notificationsRequestInFlight = ref(false)
		let notificationsPoller = null
		let notificationUnsubscribe = null

		// Загрузка истории из localStorage
		const loadSearchHistory = () => {
			try {
				const history = localStorage.getItem('searchHistory')
				if (history) {
					searchHistory.value = JSON.parse(history).slice(0, 5)
				}
			} catch (error) {
				console.error('[StudentHeader] Failed to load search history:', error)
			}
		}

		// Сохранение в историю
		const saveToHistory = query => {
			if (!query || query.length < 2) return

			const sanitized = SecurityUtils.sanitizeText(query)
			const filtered = searchHistory.value.filter(item => item !== sanitized)
			searchHistory.value = [sanitized, ...filtered].slice(0, 5)

			try {
				localStorage.setItem(
					'searchHistory',
					JSON.stringify(searchHistory.value),
				)
			} catch (error) {
				console.error('[StudentHeader] Failed to save search history:', error)
			}
		}

		// Очистка истории
		const clearSearchHistory = () => {
			searchHistory.value = []
			localStorage.removeItem('searchHistory')
		}

		const removeFromHistory = index => {
			searchHistory.value.splice(index, 1)
			localStorage.setItem('searchHistory', JSON.stringify(searchHistory.value))
		}

		// Computed свойства для поиска
		const courseResults = computed(() =>
			searchResults.value.filter(r => r.type === 'course'),
		)

		const lessonResults = computed(() =>
			searchResults.value.filter(r => r.type === 'lesson'),
		)

		const totalResults = computed(() => searchResults.value.length)

		// Computed для профиля
		const normalizeNotification = (item, index = 0) => {
			const raw = item || {}
			const id =
				raw.id || raw._id || raw.notificationId || raw.uuid || `local-${index}`
			const title = raw.title || raw.subject || raw.name || ''
			const message =
				raw.message || raw.text || raw.body || raw.description || ''
			const timestamp =
				raw.timestamp ||
				raw.createdAt ||
				raw.created_at ||
				raw.time ||
				Date.now()
			const read = Boolean(
				raw.read || raw.isRead || raw.readAt || raw.read_at || raw.seenAt,
			)
			const type = raw.type || raw.category || 'info'
			return { id, title, message, timestamp, read, type }
		}
		const safeMessagesCount = computed(() => {
			const count = parseInt(props.messagesCount) || 0
			return Math.min(Math.max(0, count), 9999)
		})

		const safeNotificationsCount = computed(() => {
			const countFromProps = parseInt(props.notificationsCount) || 0
			if (typeof unreadCount.value === 'number') {
				return Math.min(Math.max(0, unreadCount.value), 9999)
			}
			const storeCount = notificationsList.value.length
			const count = countFromProps || storeCount
			return Math.min(Math.max(0, count), 9999)
		})
		const notificationsList = computed(() => {
			if (notificationsApiAvailable.value && hasFetchedNotifications.value) {
				return notificationsListApi.value
			}
			const list = Array.isArray(appStore.notifications?.value)
				? appStore.notifications.value
				: Array.isArray(appStore.notifications)
				? appStore.notifications
				: []
			return list
				.filter(item => (item?.channel || 'toast') === 'inbox')
				.map((item, index) => normalizeNotification(item, index))
				.sort((a, b) => (b?.timestamp || 0) - (a?.timestamp || 0))
		})

		const safeUserName = computed(() => {
			const user = appStore.currentUser
			if (!user) return 'Гость'

			const fullName = user.fullName || user.full_name || ''
			const sanitized = SecurityUtils.sanitizeText(fullName)

			if (!sanitized) {
				return 'Пользователь'
			}

			const parts = sanitized.trim().split(/\s+/)
			if (parts.length >= 2) {
				return `${parts[0]} ${parts[1]}`.substring(0, 50)
			}

			return sanitized.substring(0, 50)
		})

		const userEmail = computed(() => {
			const user = appStore.currentUser
			const email = user?.email || 'user@example.com'
			return SecurityUtils.sanitizeText(email)
		})

		const maskedEmail = computed(() => {
			return SecurityUtils.maskEmail(userEmail.value)
		})

		const safeAvatarUrl = computed(() => {
			if (avatarError.value) return null

			const user = appStore.currentUser
			const url = user?.avatar || user?.avatarUrl || user?.avatar_url

			if (!url) return null

			if (!SecurityUtils.isValidImageUrl(url)) {
				console.warn('[Security] Invalid avatar URL blocked')
				return null
			}

			return url
		})

		const safeUserInitials = computed(() => {
			const name = safeUserName.value
			const parts = name.split(' ').filter(Boolean)

			if (parts.length >= 2) {
				return `${parts[0][0]}${parts[1][0]}`.toUpperCase()
			}

			return name.substring(0, 2).toUpperCase()
		})

		const messagesBadge = computed(() => {
			const count = safeMessagesCount.value
			if (count <= 0) return ''
			return count > 99 ? '99+' : String(count)
		})

		const notificationsBadge = computed(() => {
			const count = safeNotificationsCount.value
			if (count <= 0) return ''
			return count > 99 ? '99+' : String(count)
		})

		const formatNotificationTime = timestamp => {
			if (!timestamp) return ''
			const date = new Date(timestamp)
			if (Number.isNaN(date.getTime())) return ''
			return date.toLocaleString('ru-RU', {
				day: '2-digit',
				month: '2-digit',
				year: '2-digit',
				hour: '2-digit',
				minute: '2-digit',
			})
		}

		const setNotificationsFromApi = payload => {
			const list = Array.isArray(payload?.notifications)
				? payload.notifications
				: Array.isArray(payload)
				? payload
				: []
			notificationsListApi.value = list.map((item, index) =>
				normalizeNotification(item, index),
			)
			hasFetchedNotifications.value = true
			if (typeof payload?.unreadCount === 'number') {
				unreadCount.value = payload.unreadCount
			}
		}

		const addIncomingNotification = payload => {
			const incoming = normalizeNotification(payload, 0)
			if (!incoming?.id) return
			const exists = notificationsListApi.value.some(
				item => String(item.id) === String(incoming.id),
			)
			if (!exists) {
				notificationsListApi.value = [incoming, ...notificationsListApi.value]
			}
			hasFetchedNotifications.value = true
			notificationsApiAvailable.value = true
			if (typeof unreadCount.value === 'number') {
				unreadCount.value = unreadCount.value + 1
			} else {
				unreadCount.value = notificationsListApi.value.length
			}
		}

		const isRateLimitError = error => {
			const status = Number(error?.status ?? error?.response?.status ?? 0)
			return status === 429
		}

		const getRetryAfterMs = (error, fallbackMs = 60000) => {
			const retryAfterHeader =
				error?.response?.headers?.['retry-after'] ||
				error?.response?.headers?.RetryAfter ||
				null
			if (!retryAfterHeader) return fallbackMs
			const retryAfterSeconds = Number(retryAfterHeader)
			if (Number.isFinite(retryAfterSeconds)) {
				return Math.max(1000, retryAfterSeconds * 1000)
			}
			const retryAfterDate = Date.parse(retryAfterHeader)
			if (!Number.isNaN(retryAfterDate)) {
				return Math.max(1000, retryAfterDate - Date.now())
			}
			return fallbackMs
		}

		const hasNotificationsBackoff = () =>
			notificationsBackoffUntil.value > Date.now()

		const fetchUnreadCount = async () => {
			if (!notificationsApiAvailable.value) return
			if (unreadCountRequestInFlight.value) return
			if (hasNotificationsBackoff()) return
			unreadCountRequestInFlight.value = true
			try {
				const response = await api.get(NOTIFICATIONS_COUNT_ENDPOINT)
				const payload = response?.data?.data || response?.data || {}
				if (typeof payload?.unreadCount === 'number') {
					unreadCount.value = payload.unreadCount
				}
				notificationsBackoffUntil.value = 0
			} catch (error) {
				if (isRateLimitError(error)) {
					const retryAfterMs = getRetryAfterMs(error, 60000)
					notificationsBackoffUntil.value = Date.now() + retryAfterMs
					console.warn(
						`[StudentHeader] Notifications count rate-limited, retry in ${Math.ceil(
							retryAfterMs / 1000,
						)}s`,
					)
					return
				}
				notificationsApiAvailable.value = false
				console.warn('[StudentHeader] Notifications count unavailable:', error)
			} finally {
				unreadCountRequestInFlight.value = false
			}
		}

		const fetchNotifications = async () => {
			if (!notificationsApiAvailable.value) return
			if (notificationsRequestInFlight.value) return
			if (hasNotificationsBackoff()) {
				const remainingSec = Math.max(
					1,
					Math.ceil((notificationsBackoffUntil.value - Date.now()) / 1000),
				)
				notificationsError.value = `Слишком много запросов. Повторите через ${remainingSec} сек.`
				return
			}
			notificationsRequestInFlight.value = true
			notificationsLoading.value = true
			notificationsError.value = ''
			try {
				const response = await api.get(NOTIFICATIONS_ENDPOINT, {
					params: { limit: 50, unreadOnly: true },
				})
				const payload = response?.data?.data || response?.data || {}
				setNotificationsFromApi(payload)
				if (typeof payload?.unreadCount === 'number') {
					unreadCount.value = payload.unreadCount
				}
				notificationsBackoffUntil.value = 0
			} catch (error) {
				if (isRateLimitError(error)) {
					const retryAfterMs = getRetryAfterMs(error, 60000)
					notificationsBackoffUntil.value = Date.now() + retryAfterMs
					notificationsError.value = `Слишком много запросов. Повторите через ${Math.ceil(
						retryAfterMs / 1000,
					)} сек.`
					console.warn(
						`[StudentHeader] Notifications rate-limited, retry in ${Math.ceil(
							retryAfterMs / 1000,
						)}s`,
					)
					return
				}
				notificationsApiAvailable.value = false
				notificationsError.value =
					error?.message || 'Не удалось загрузить уведомления'
				console.warn('[StudentHeader] Notifications unavailable:', error)
			} finally {
				notificationsLoading.value = false
				notificationsRequestInFlight.value = false
			}
		}

		const startNotificationsPolling = () => {
			if (notificationsPoller) return
			notificationsPoller = setInterval(() => {
				if (!notificationsApiAvailable.value) return
				fetchUnreadCount()
			}, 45000)
		}

		const stopNotificationsPolling = () => {
			if (notificationsPoller) {
				clearInterval(notificationsPoller)
				notificationsPoller = null
			}
		}

		// Подсветка совпадений в результатах
		const highlightMatch = text => {
			if (!searchQuery.value) return SecurityUtils.sanitizeText(text)

			const sanitizedText = SecurityUtils.sanitizeText(text)
			const sanitizedQuery = SecurityUtils.sanitizeText(searchQuery.value)

			const regex = new RegExp(`(${sanitizedQuery})`, 'gi')
			return sanitizedText.replace(regex, '<mark>$1</mark>')
		}

		// Основная функция поиска (с debounce)
		const performSearch = debounce(async query => {
			if (!query || query.length < 2) {
				searchResults.value = []
				isSearching.value = false
				return
			}

			isSearching.value = true

			try {
				const sanitizedQuery = SecurityUtils.sanitizeText(query)
				const results = await searchService.search(sanitizedQuery)

				searchResults.value = results

				// Генерируем предложения если нет результатов
				if (searchResults.value.length === 0) {
					searchSuggestions.value = [
						`${sanitizedQuery} основы`,
						`${sanitizedQuery} для начинающих`,
						`Курс ${sanitizedQuery}`,
					]
				} else {
					searchSuggestions.value = []
				}
			} catch (error) {
				console.error('[StudentHeader] Search error:', error)
				searchResults.value = []
			} finally {
				isSearching.value = false
			}
		}, 300)

		// Обработчики событий поиска
		const handleSearchFocus = () => {
			searchFocused.value = true
			showSearchDropdown.value = true
			loadSearchHistory()
		}

		const handleSearchBlur = () => {
			searchFocused.value = false
			setTimeout(() => {
				if (!searchContainer.value?.contains(document.activeElement)) {
					showSearchDropdown.value = false
				}
			}, 200)
		}

		const handleSearchInput = () => {
			selectedIndex.value = -1
			if (searchQuery.value.length >= 2) {
				performSearch(searchQuery.value)
			} else {
				searchResults.value = []
			}
		}

		// Навигация клавиатурой
		const handleSearchKeydown = event => {
			const resultsCount = searchResults.value.length

			switch (event.key) {
				case 'ArrowDown':
					event.preventDefault()
					if (selectedIndex.value < resultsCount - 1) {
						selectedIndex.value++
					} else {
						selectedIndex.value = 0
					}
					break

				case 'ArrowUp':
					event.preventDefault()
					if (selectedIndex.value > 0) {
						selectedIndex.value--
					} else {
						selectedIndex.value = resultsCount - 1
					}
					break

				case 'Enter':
					event.preventDefault()
					if (selectedIndex.value >= 0) {
						const selected = searchResults.value[selectedIndex.value]
						selectResult(selected)
					} else {
						executeSearch()
					}
					break

				case 'Escape':
					event.preventDefault()
					clearSearch()
					showSearchDropdown.value = false
					searchInput.value?.blur()
					break
			}
		}

		// Выполнение поиска
		const executeSearch = () => {
			if (!searchQuery.value.trim()) return

			saveToHistory(searchQuery.value)
			emit('search', searchQuery.value)

			router.push({
				path: '/student/search',
				query: { q: searchQuery.value },
			})

			showSearchDropdown.value = false
		}

		// Выбор результата
		const selectResult = result => {
			saveToHistory(searchQuery.value)
			showSearchDropdown.value = false

			if (result.type === 'course') {
				router.push({ name: 'CoursePreview', params: { id: result.id } })
			} else if (result.type === 'lesson') {
				router.push(`/student/lesson/${result.id}`)
			}
		}

		// Выбор из истории
		const selectFromHistory = item => {
			searchQuery.value = item
			performSearch(item)
		}

		// Выбор предложения
		const selectSuggestion = suggestion => {
			searchQuery.value = suggestion
			performSearch(suggestion)
		}

		// Очистка поиска
		const clearSearch = () => {
			searchQuery.value = ''
			searchResults.value = []
			selectedIndex.value = -1
		}

		// Показать все результаты
		const showAllResults = () => {
			executeSearch()
		}

		// Остальные обработчики
		const handleMessages = () => emit('open-messages')
		const clearNotifications = async () => {
			if (notificationsApiAvailable.value) {
				try {
					await api.post(NOTIFICATIONS_READ_ALL_ENDPOINT)
					notificationsListApi.value = []
					unreadCount.value = 0
				} catch (error) {
					console.warn('[StudentHeader] Failed to clear notifications:', error)
				}
			} else {
				appStore.clearNotifications('inbox')
			}
			notificationsOpen.value = false
		}
		const removeNotification = async id => {
			const idValue = String(id || '')
			if (notificationsApiAvailable.value && !idValue.startsWith('local-')) {
				try {
					await api.patch(`${NOTIFICATIONS_ENDPOINT}/${id}/read`)
					notificationsListApi.value = notificationsListApi.value.filter(
						item => String(item.id) !== idValue,
					)
					if (typeof unreadCount.value === 'number') {
						unreadCount.value = Math.max(unreadCount.value - 1, 0)
					}
					return
				} catch (error) {
					console.warn(
						'[StudentHeader] Failed to mark notification read:',
						error,
					)
				}
			}
			appStore.removeNotification(id)
		}

		const handleNotifications = () => {
			notificationsOpen.value = !notificationsOpen.value
			if (notificationsOpen.value) {
				closeDropdown()
				fetchNotifications()
			}
			emit('open-notifications')
		}

		const handleAvatarError = () => {
			avatarError.value = true
			console.warn('[Security] Avatar failed to load')
		}

		const toggleDropdown = () => {
			isOpen.value = !isOpen.value
		}

		const closeDropdown = () => {
			isOpen.value = false
		}

		const handleLogout = async () => {
			if (isLoggingOut.value) return

			if (!logoutRateLimiter('logout')) {
				appStore.showWarning('Слишком много попыток. Подождите немного')
				return
			}

			isLoggingOut.value = true

			try {
				closeDropdown()

				const { authService } = await import('@/services/auth')
				await authService.logout()

				appStore.clearUserData()

				appStore.showSuccess('Вы успешно вышли из системы')
				emit('logout')

				// В режиме Bitrix24 не перенаправляем, просто очищаем данные
				const isBitrix24Mode = localStorage.getItem('bitrix24_mode') === 'true' || (() => { try { return window.self !== window.top } catch (_) { return true } })()
				if (isBitrix24Mode) {
					router.replace('/bitrix24-auth')
				} else {
					router.replace('/auth')
				}
			} catch (error) {
				if (process.env.NODE_ENV === 'development') {
					console.error('[StudentHeader] Logout error:', error.message)
				}

				appStore.showError('Ошибка при выходе из системы')

				if (error.response?.status === 401) {
					appStore.clearUserData()
					const isBitrix24Mode = localStorage.getItem('bitrix24_mode') === 'true' || (() => { try { return window.self !== window.top } catch (_) { return true } })()
					if (isBitrix24Mode) {
					router.replace('/bitrix24-auth')
				} else {
					router.replace('/auth')
				}
				}
			} finally {
				isLoggingOut.value = false
			}
		}

		const handleClickOutside = e => {
			const isProfileClick = profileContainer.value?.contains(e.target)
			const isNotificationClick = notificationsContainer.value?.contains(
				e.target,
			)
			if (!isProfileClick) {
				closeDropdown()
			}
			if (!isNotificationClick) {
				notificationsOpen.value = false
			}
		}

		const handleEscape = e => {
			if (e.key !== 'Escape') return
			if (isOpen.value) {
				closeDropdown()
				dropdownTrigger.value?.focus()
			}
			if (notificationsOpen.value) {
				notificationsOpen.value = false
			}
		}

		// Защита от clickjacking (отключена для Bitrix24)
		onMounted(() => {
			const isBitrix24Mode = localStorage.getItem('bitrix24_mode') === 'true' || (() => { try { return window.self !== window.top } catch (_) { return true } })()
			
			if (window.self !== window.top && !isBitrix24Mode) {
				console.warn('[Security] App loaded in iframe, redirecting to top')
				try {
					window.top.location = window.self.location
				} catch (e) {
					console.error('[Security] Cannot redirect to top:', e)
				}
			} else if (isBitrix24Mode) {
				console.log('[Security] Bitrix24 mode - iframe allowed')
			}

			document.addEventListener('click', handleClickOutside)
			document.addEventListener('keydown', handleEscape)
			loadSearchHistory()
			fetchUnreadCount()
			startNotificationsPolling()
			notificationUnsubscribe = accountSocket.onNotification(payload => {
				addIncomingNotification(payload)
			})
		})

		onBeforeUnmount(() => {
			document.removeEventListener('click', handleClickOutside)
			document.removeEventListener('keydown', handleEscape)
			searchQuery.value = ''
			stopNotificationsPolling()
			if (notificationUnsubscribe) {
				notificationUnsubscribe()
				notificationUnsubscribe = null
			}
		})

		return {
			// Поиск
			searchContainer,
			searchInput,
			searchQuery,
			searchFocused,
			showSearchDropdown,
			isSearching,
			searchResults,
			selectedIndex,
			searchHistory,
			searchSuggestions,
			courseResults,
			lessonResults,
			totalResults,

			// Методы поиска
			handleSearchFocus,
			handleSearchBlur,
			handleSearchInput,
			handleSearchKeydown,
			executeSearch,
			selectResult,
			selectFromHistory,
			selectSuggestion,
			clearSearch,
			clearSearchHistory,
			removeFromHistory,
			showAllResults,
			highlightMatch,

			// Профиль
			isOpen,
			isLoggingOut,
			profileContainer,
			dropdownTrigger,
			notificationsOpen,
			notificationsContainer,

			// Computed
			safeMessagesCount,
			safeNotificationsCount,
			notificationsList,
			safeUserName,
			maskedEmail,
			safeAvatarUrl,
			safeUserInitials,
			messagesBadge,
			notificationsBadge,

			// Methods
			handleMessages,
			handleNotifications,
			clearNotifications,
			formatNotificationTime,
			removeNotification,
			handleAvatarError,
			toggleDropdown,
			closeDropdown,
			handleLogout,
		}
	},
}
</script>

<style scoped>
/* MODERN DESIGN WITH PROPER LAYOUT */
.sh-header {
	/* position: sticky; */
	position: relative;
	top: 0;
	z-index: 10000;
	background: rgba(255, 255, 255, 0.95);
	backdrop-filter: blur(20px);
	-webkit-backdrop-filter: blur(20px);
	border-bottom: 1px solid rgba(0, 0, 0, 0.06);
	height: 72px;
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	/* Защита от clickjacking */
	opacity: 1 !important;
	pointer-events: auto !important;
}

.sh-header:hover {
	background: rgba(255, 255, 255, 0.98);
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.sh-container {
	max-width: 1400px;
	margin: 0 auto;
	padding: 0 24px;
	height: 100%;
	display: flex;
	align-items: center;
	gap: 32px;
}

/* LOGO */
.sh-logo {
	flex-shrink: 0;
}

/* .sh-logo-wrapper {
  display: flex;
  align-items: center;
  height: 40px;
  padding: 8px 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.sh-logo-wrapper:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);
} */

/* NAVIGATION */
.sh-nav {
	transform: translateX(200px);
	display: flex;
	gap: 12px;
	flex: 1;
}

.sh-notifications {
	position: relative;
	display: inline-flex;
}

.sh-notifications-dropdown {
	position: absolute;
	top: calc(100% + 12px);
	right: 0;
	min-width: 280px;
	max-width: 360px;
	background: #fff;
	border: 1px solid rgba(0, 0, 0, 0.08);
	border-radius: 14px;
	box-shadow: 0 16px 32px rgba(15, 23, 42, 0.14);
	padding: 12px;
	z-index: 999999999999;
}

.sh-notifications-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-weight: 600;
	font-size: 14px;
	color: #1f2937;
	margin-bottom: 10px;
}

.sh-notifications-clear {
	border: none;
	background: transparent;
	color: #2563eb;
	font-size: 12px;
	cursor: pointer;
}

.sh-notifications-clear:hover {
	text-decoration: underline;
}

.sh-notifications-empty {
	font-size: 12px;
	color: #6b7280;
	padding: 8px 0;
}

.sh-notifications-list {
	list-style: none;
	margin: 0;
	padding: 0;
	display: flex;
	flex-direction: column;
	gap: 10px;
	max-height: 320px;
	overflow-y: auto;
}

.sh-notifications-item {
	border: 1px solid rgba(15, 23, 42, 0.08);
	border-radius: 12px;
	padding: 10px 12px;
	background: #f8fafc;
	position: relative;
	padding-right: 34px;
}

.sh-notifications-item-title {
	font-size: 13px;
	font-weight: 600;
	color: #111827;
	margin-bottom: 4px;
}

.sh-notifications-item-text {
	font-size: 12px;
	color: #4b5563;
	margin-bottom: 6px;
}

.sh-notifications-item-time {
	font-size: 11px;
	color: #9ca3af;
}

.sh-notifications-close {
	position: absolute;
	top: 8px;
	right: 8px;
	width: 20px;
	height: 20px;
	padding: 0;
	border: none;
	border-radius: 6px;
	background: transparent;
	color: #94a3b8;
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	transition: color 0.2s ease, background 0.2s ease;
}

.sh-notifications-close:hover {
	color: #1f2937;
	background: rgba(15, 23, 42, 0.06);
}

.sh-notifications-close svg {
	width: 14px;
	height: 14px;
}

/* Общие стили для навигационных элементов */
.sh-nav-link,
.sh-nav-btn {
	position: relative;
	padding: 8px 16px;
	border-radius: 12px;
	text-decoration: none;
	color: #64748b;
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	overflow: hidden;
	background: transparent;
	border: none;
	cursor: pointer;
	font-family: inherit;
}

.sh-nav-link-content,
.sh-nav-btn-content {
	display: flex;
	align-items: center;
	gap: 10px;
	position: relative;
	z-index: 2;
}

.sh-nav-icon-wrapper {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	border-radius: 10px;
	background: rgba(148, 163, 184, 0.1);
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.sh-nav-icon {
	width: 20px;
	height: 20px;
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.sh-nav-label {
	font-weight: 500;
	font-size: 14px;
	letter-spacing: 0.2px;
}

/* Индикаторы */
.sh-nav-link-indicator,
.sh-nav-btn-indicator {
	position: absolute;
	bottom: 0;
	left: 50%;
	transform: translateX(-50%) scaleX(0);
	width: 24px;
	height: 3px;
	background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
	border-radius: 3px 3px 0 0;
	transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Hover эффекты */
.sh-nav-link:hover,
.sh-nav-btn:hover {
	color: #475569;
	background: rgba(148, 163, 184, 0.08);
}

.sh-nav-link:hover .sh-nav-icon-wrapper,
.sh-nav-btn:hover .sh-nav-icon-wrapper {
	background: rgba(148, 163, 184, 0.15);
	transform: scale(1.05);
}

/* Активные состояния */
.sh-nav-link.router-link-active {
	color: #667eea;
	background: linear-gradient(
		135deg,
		rgba(102, 126, 234, 0.08) 0%,
		rgba(118, 75, 162, 0.08) 100%
	);
}

.sh-nav-link.router-link-active .sh-nav-icon-wrapper {
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	color: white;
}

.sh-nav-link.router-link-active .sh-nav-link-indicator {
	transform: translateX(-50%) scaleX(1);
}

.sh-nav-btn--active {
	color: #667eea;
}

.sh-nav-btn--active .sh-nav-icon-wrapper {
	background: rgba(102, 126, 234, 0.15);
}

.sh-nav-btn--active .sh-nav-btn-indicator {
	transform: translateX(-50%) scaleX(1);
}

/* BADGES в навигации */
.sh-nav-icon-wrapper .sh-badge {
	position: absolute;
	top: -4px;
	right: -4px;
	min-width: 18px;
	height: 18px;
	padding: 0 5px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 10px;
	font-weight: 700;
	border-radius: 9px;
	color: white;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
	animation: none;
}

.sh-badge--primary {
	background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
}

.sh-badge--danger {
	background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
}

/* Анимация при появлении бейджа */
.badge-pop-enter-active {
	animation: badgePop 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

@keyframes badgePop {
	0% {
		transform: scale(0);
	}
	50% {
		transform: scale(1.2);
	}
	100% {
		transform: scale(1);
	}
}

/* Анимация иконки при наличии бейджа */
.sh-nav-btn--active .sh-nav-icon {
	animation: wiggle 2s ease-in-out infinite;
}

@keyframes wiggle {
	0%,
	100% {
		transform: rotate(0deg);
	}
	25% {
		transform: rotate(-5deg);
	}
	75% {
		transform: rotate(5deg);
	}
}

/* ACTIONS (правая часть) */
.sh-actions {
	display: flex;
	align-items: center;
	gap: 16px;
	flex-shrink: 0;
}

/* УЛУЧШЕННЫЙ ПОИСК */
.sh-search {
	position: relative;
	width: 280px;
	max-width: 280px;
	min-width: 280px;
	transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.sh-search--active {
	width: 280px;
}

.sh-search-field {
	position: relative;
	display: flex;
	align-items: center;
}

.sh-search-input {
	width: 100%;
	height: 40px;
	padding: 0 80px 0 16px;
	background: #f1f5f9;
	border: 2px solid transparent;
	border-radius: 20px;
	font-size: 14px;
	font-family: 'Inter', -apple-system, sans-serif;
	color: #334155;
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	outline: none;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.sh-search-input:focus {
	background: white;
	border-color: #667eea;
	box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.sh-search-clear {
	position: absolute;
	right: 40px;
	width: 24px;
	height: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: transparent;
	border: none;
	color: #94a3b8;
	cursor: pointer;
	border-radius: 50%;
	transition: all 0.2s;
}

.sh-search-clear:hover {
	background: rgba(148, 163, 184, 0.1);
	color: #64748b;
}

.sh-search-btn {
	position: absolute;
	right: 4px;
	top: 50%;
	transform: translateY(-50%);
	width: 32px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: transparent;
	border: none;
	border-radius: 50%;
	color: #94a3b8;
	cursor: pointer;
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.sh-search-btn svg {
	width: 18px;
	height: 18px;
}

.sh-search-btn:hover {
	background: rgba(148, 163, 184, 0.1);
	color: #64748b;
}

.sh-search-btn--active {
	color: #667eea;
	background: rgba(102, 126, 234, 0.1);
}

.sh-search-spinner svg {
	animation: spin 1s linear infinite;
}

@keyframes spin {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
}

/* PROFILE */
.sh-profile {
	position: relative;
	transform: translateX(100px);
}

.sh-profile-btn {
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 6px 12px 6px 6px;
	background: linear-gradient(
		135deg,
		rgba(241, 245, 249, 0.8) 0%,
		rgba(226, 232, 240, 0.8) 100%
	);
	border: 1px solid rgba(148, 163, 184, 0.2);
	border-radius: 50px;
	cursor: pointer;
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.sh-profile-btn:hover {
	background: white;
	border-color: rgba(148, 163, 184, 0.3);
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
	transform: translateY(-1px);
}

.sh-profile-avatar {
	position: relative;
	width: 36px;
	height: 36px;
	border-radius: 50%;
	overflow: visible;
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}
.sh-profile-avatar-clip {
	width: 100%;
	height: 100%;
	border-radius: 50%;
	overflow: hidden; /* обрезаем только картинку/плейсхолдер */
}

.sh-profile-avatar-img {
	width: 100%;
	height: 100%;
	object-fit: cover;
	/* Предотвращаем выход изображения за границы */
	max-width: 100%;
	max-height: 100%;
	/* Изолируем стили изображения */
	contain: layout style paint;
}

.sh-profile-avatar-placeholder {
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	color: white;
	font-weight: 600;
	font-size: 14px;
}

.sh-profile-status {
	position: absolute;
	bottom: -1px; /* можно чуть наружу */
	right: -1px;
	width: 10px;
	height: 10px;
	background: #10b981;
	border: 2px solid white;
	border-radius: 50%;
	z-index: 10;
}

@keyframes pulse {
	0%,
	100% {
		transform: scale(1);
		opacity: 1;
	}
	50% {
		transform: scale(1.1);
		opacity: 0.8;
	}
}

.sh-profile-info {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
}

.sh-profile-name {
	font-size: 14px;
	font-weight: 600;
	color: #1e293b;
	line-height: 1.2;
}

.sh-profile-role {
	font-size: 12px;
	color: #64748b;
	line-height: 1.2;
}

.sh-profile-arrow {
	width: 20px;
	height: 20px;
	color: #64748b;
	transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.sh-profile-arrow--open {
	transform: rotate(180deg);
}

/* DROPDOWN - остальные стили остаются без изменений */
.sh-dropdown {
	position: absolute;
	top: calc(100% + 8px);
	right: 0;
	width: 280px;
	background: white;
	border: 1px solid rgba(148, 163, 184, 0.15);
	border-radius: 16px;
	box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);
	overflow: hidden;
	/* Изолируем dropdown от остального контента */
	contain: layout style;
	/* Предотвращаем выход за viewport */
	max-height: calc(100vh - 100px);
	overflow-y: auto;
	z-index: 10001;
}

.sh-dropdown-header {
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 16px;
	background: linear-gradient(
		135deg,
		rgba(102, 126, 234, 0.05) 0%,
		rgba(118, 75, 162, 0.05) 100%
	);
}

.sh-dropdown-avatar {
	width: 48px;
	height: 48px;
	border-radius: 50%;
	overflow: hidden;
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	flex-shrink: 0;
}

.sh-dropdown-avatar img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.sh-dropdown-avatar-placeholder {
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	color: white;
	font-weight: 600;
	font-size: 18px;
}

.sh-dropdown-user {
	flex: 1;
	min-width: 0;
}

.sh-dropdown-username {
	font-weight: 600;
	font-size: 14px;
	color: #1e293b;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.sh-dropdown-email {
	font-size: 12px;
	color: #64748b;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	/* Отключаем возможность выделения чувствительной информации */
	user-select: none;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
}

.sh-dropdown-divider {
	height: 1px;
	background: rgba(148, 163, 184, 0.15);
	margin: 0;
}

.sh-dropdown-item {
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 12px 16px;
	color: #475569;
	text-decoration: none;
	font-size: 14px;
	font-weight: 500;
	background: transparent;
	border: none;
	width: 100%;
	text-align: left;
	cursor: pointer;
	transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
	position: relative;
}

.sh-dropdown-item:hover {
	background: rgba(148, 163, 184, 0.08);
	color: #1e293b;
	padding-left: 20px;
}

.sh-dropdown-item--danger {
	color: #dc2626;
}

.sh-dropdown-item--danger:hover {
	background: rgba(239, 68, 68, 0.08);
	color: #b91c1c;
}

.sh-dropdown-icon {
	width: 20px;
	height: 20px;
	flex-shrink: 0;
}

.sh-dropdown-item span {
	flex: 1;
}

.sh-dropdown-badge {
	margin-left: auto;
	padding: 2px 8px;
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	color: white;
	font-size: 11px;
	font-weight: 600;
	border-radius: 10px;
}

/* ANIMATIONS */
.sh-dropdown-enter-active,
.sh-dropdown-leave-active {
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.sh-dropdown-enter-from,
.sh-dropdown-leave-to {
	opacity: 0;
	transform: translateY(-10px) scale(0.95);
}

/* RESPONSIVE */
@media (max-width: 1200px) {
	.sh-container {
		padding: 0 16px;
		gap: 20px;
	}

	.sh-search {
		width: 200px;
		max-width: 200px;
		min-width: 200px;
	}
}

@media (max-width: 992px) {
	.sh-nav {
		gap: 8px;
	}

	.sh-nav-label {
		display: none;
	}

	.sh-search {
		width: 180px;
		max-width: 180px;
		min-width: 180px;
	}
}

@media (max-width: 768px) {
	.sh-header {
		height: 64px;
	}

	.sh-profile-info {
		display: none;
	}

	.sh-actions {
		gap: 8px;
	}
}

@media (max-width: 576px) {
	.sh-container {
		padding: 0 12px;
		gap: 12px;
	}

	.sh-logo-wrapper {
		padding: 6px 10px;
	}

	.sh-nav {
		gap: 4px;
	}

	.sh-nav-link,
	.sh-nav-btn {
		padding: 8px;
	}

	.sh-search {
		display: none;
	}

	.sh-dropdown {
		width: 260px;
		right: -8px;
	}
}

/* DROPDOWN С РЕЗУЛЬТАТАМИ ПОИСКА */
.sh-search-dropdown {
	position: absolute;
	top: calc(100% + 8px);
	left: 0;
	right: 0;
	background: white;
	border: 1px solid rgba(148, 163, 184, 0.15);
	border-radius: 16px;
	box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);
	max-height: 480px;
	overflow-y: auto;
	z-index: 10001;
	contain: layout style;
}

/* Секции */
.sh-search-section-title {
	font-size: 12px;
	font-weight: 600;
	color: #64748b;
	text-transform: uppercase;
	letter-spacing: 0.5px;
	padding: 12px 16px 8px;
}

.sh-search-section-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 12px 16px 8px;
}

.sh-search-clear-history {
	font-size: 12px;
	color: #94a3b8;
	background: none;
	border: none;
	cursor: pointer;
	transition: color 0.2s;
}

.sh-search-clear-history:hover {
	color: #667eea;
}

/* Быстрые теги */
.sh-search-tags {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	padding: 0 16px 12px;
}

.sh-search-tag {
	display: inline-flex;
	align-items: center;
	gap: 4px;
	padding: 6px 12px;
	background: #f1f5f9;
	border: 1px solid transparent;
	border-radius: 20px;
	font-size: 13px;
	color: #475569;
	cursor: pointer;
	transition: all 0.2s;
}

.sh-search-tag:hover {
	background: white;
	border-color: #667eea;
	color: #667eea;
}

/* История поиска */
.sh-search-history-item {
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 10px 16px;
	width: 100%;
	background: none;
	border: none;
	text-align: left;
	cursor: pointer;
	transition: background 0.2s;
	position: relative;
}

.sh-search-history-item:hover {
	background: rgba(148, 163, 184, 0.08);
}

.sh-search-history-item svg {
	color: #94a3b8;
	flex-shrink: 0;
}

.sh-search-history-item span {
	flex: 1;
	font-size: 14px;
	color: #334155;
}

.sh-search-history-remove {
	padding: 4px;
	background: none;
	border: none;
	color: #94a3b8;
	cursor: pointer;
	border-radius: 4px;
	opacity: 0;
	transition: all 0.2s;
}

.sh-search-history-item:hover .sh-search-history-remove {
	opacity: 1;
}

.sh-search-history-remove:hover {
	background: rgba(239, 68, 68, 0.1);
	color: #ef4444;
}

/* Результаты */
.sh-search-category {
	border-bottom: 1px solid rgba(148, 163, 184, 0.1);
	padding-bottom: 8px;
	margin-bottom: 8px;
}

.sh-search-category:last-child {
	border-bottom: none;
	margin-bottom: 0;
}

.sh-search-category-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 8px 16px;
}

.sh-search-category-title {
	font-size: 12px;
	font-weight: 600;
	color: #64748b;
	text-transform: uppercase;
	letter-spacing: 0.5px;
}

.sh-search-category-count {
	font-size: 12px;
	padding: 2px 8px;
	background: #f1f5f9;
	border-radius: 10px;
	color: #64748b;
}

.sh-search-result {
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 10px 16px;
	text-decoration: none;
	color: #334155;
	transition: all 0.2s;
	position: relative;
}

.sh-search-result:hover,
.sh-search-result--active {
	background: linear-gradient(
		90deg,
		rgba(102, 126, 234, 0.08) 0%,
		rgba(118, 75, 162, 0.08) 100%
	);
}

.sh-search-result-icon {
	width: 32px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #f1f5f9;
	border-radius: 8px;
	color: #667eea;
	flex-shrink: 0;
}

.sh-search-result-content {
	flex: 1;
	min-width: 0;
}

.sh-search-result-title {
	font-size: 14px;
	font-weight: 500;
	color: #1e293b;
	margin-bottom: 2px;
}

.sh-search-result-title mark {
	background: rgba(102, 126, 234, 0.2);
	color: inherit;
	padding: 0 2px;
	border-radius: 2px;
}

.sh-search-result-meta {
	font-size: 12px;
	color: #94a3b8;
}

.sh-search-result-badge {
	padding: 2px 6px;
	background: linear-gradient(135deg, #10b981 0%, #059669 100%);
	color: white;
	font-size: 10px;
	font-weight: 700;
	border-radius: 4px;
}

/* Показать все */
.sh-search-show-all {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	padding: 12px;
	width: 100%;
	background: #f8fafc;
	border: none;
	color: #667eea;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	transition: background 0.2s;
}

.sh-search-show-all:hover {
	background: #f1f5f9;
}

/* Загрузка */
.sh-search-loading {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 32px;
	gap: 12px;
	color: #94a3b8;
}

.sh-search-loading-spinner {
	width: 24px;
	height: 24px;
	border: 2px solid rgba(102, 126, 234, 0.2);
	border-top-color: #667eea;
	border-radius: 50%;
	animation: spin 0.8s linear infinite;
}

/* Пустые результаты */
.sh-search-empty {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 32px 16px;
	text-align: center;
}

.sh-search-empty svg {
	color: #cbd5e1;
	margin-bottom: 16px;
}

.sh-search-empty-title {
	font-size: 16px;
	font-weight: 600;
	color: #334155;
	margin-bottom: 4px;
}

.sh-search-empty-text {
	font-size: 14px;
	color: #94a3b8;
	margin-bottom: 24px;
}

.sh-search-suggestions {
	width: 100%;
}

.sh-search-suggestions-title {
	font-size: 13px;
	color: #64748b;
	margin-bottom: 12px;
}

/* Анимация dropdown */
.search-dropdown-enter-active,
.search-dropdown-leave-active {
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.search-dropdown-enter-from,
.search-dropdown-leave-to {
	opacity: 0;
	transform: translateY(-10px);
}

/* Responsive для поиска */
@media (max-width: 768px) {
	.sh-search-dropdown {
		position: fixed;
		left: 16px;
		right: 16px;
		top: 80px;
	}
}
</style>

